import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import SvgIcon from "@material-ui/core/SvgIcon";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import Button from "components/CustomButtons/Button.jsx";

import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";
import { successColor } from "assets/jss/material-kit-react";

function SuccessIcon(props) {
    return (
        <SvgIcon {...props}>
            <path fill="none" d="M0 0h24v24H0V0zm0 0h24v24H0V0z"/>
            <path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        </SvgIcon>
    )
}

class SuccessDialog extends React.Component {
    render(){
        const { classes, onClose, isOpened, } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={onClose}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={onClose}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Готово!</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <SuccessIcon style={{fontSize: "11em", margin: "0.5em", color: successColor}}/>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" simple
                            onClick={onClose}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

SuccessDialog.propTypes = {
    isOpened: PropTypes.bool,
    onClose: PropTypes.func,
};

export default withStyles(modalStyle)(SuccessDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/SuccessDialog.jsx